var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "action-items" },
    _vm._l(_vm.actions, function(action, index) {
      return _c(
        "div",
        { key: index },
        [
          _c("BaseActionItem", {
            attrs: {
              name: action.name,
              value: action.value,
              accessory: action.accessory,
              flip: action.flip,
              clickHandler: action.clickHandler,
              hideBorder: _vm.lastActionItem(index),
              disabled: action.disabled || false,
              error: action.error || false
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71cdb690", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71cdb690","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseActions.vue
// module id = null
// module chunks = 